import { useEffect, useMemo, useState } from "react"
import DefaultModal from "../../../components/modal/DefaultModal/DefaultModal"
import { Input } from "../../../components/ui/input"
import { RoundedButton } from "../../../components/ui/roundButton"

const toApiPayload = ({ name, description }) => ({
  name: name?.trim(),
  description: description?.trim(),
})

const validateFields = ({ name }) => {
  const errors = []

  if (!name?.trim()) {
    errors.push("Nome não pode ser vazio.")
  }

  return errors
}

const CategoriesModal = ({
  open,
  onClose,
  onSubmit,
  initialValue,
  submitLabel = "Salvar",
}) => {
  const [name, setName] = useState(initialValue?.name || "")
  const [description, setDescription] = useState(initialValue?.description || "")

  useEffect(() => {
    if (!open) return

    setName(initialValue?.name || "")
    setDescription(initialValue?.description || "")
  }, [open, initialValue])

  const errors = useMemo(() => validateFields({ name }), [name])

  const handleSubmit = () => {
    if (errors.length > 0) return

    onSubmit({
      ...initialValue,
      ...toApiPayload({ name, description }),
    })
  }

  return (
    <DefaultModal
      open={open}
      handleClose={onClose}
      title="Categoria"
      maxWidth="xs"
      action={
        <div style={{ display: "flex", gap: 12 }}>
          <RoundedButton rounded="outlined" onClick={onClose} sx={{ flex: 1 }}>
            Cancelar
          </RoundedButton>
          <RoundedButton onClick={handleSubmit} disabled={errors.length > 0} sx={{ flex: 1 }}>
            {submitLabel}
          </RoundedButton>
        </div>
      }
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <label className="space-y-1.5">
          <span className="block text-sm font-semibold text-gray-600">Nome</span>
          <Input
            value={name}
            onChange={({ target }) => setName(target.value)}
            placeholder="Informe o nome da categoria"
          />
        </label>

        <label className="space-y-1.5">
          <span className="block text-sm font-semibold text-gray-600">Descrição (opcional)</span>
          <textarea
            value={description}
            onChange={({ target }) => setDescription(target.value)}
            placeholder="Descreva a categoria - ajuda o modelo de IA a diferenciar esta categoria das demais"
            rows={4}
            className="w-full rounded-md border border-input bg-background px-3 py-2 text-base outline-none placeholder:text-muted-foreground"
          />
        </label>
      </div>
    </DefaultModal>
  )
}

export default CategoriesModal
